query getPersonPageTitleQuery($id: String!) {
  person: getPerson(aggregateId: $id) {
    preferredName
    firstName
    surname
  }
}

query getTeamTitleQuery($id: String!) {
  team: getGroup(groupId: $id) {
    name
    type
  }
}

query getTagPageTitleQuery($id: ID) {
  tag: searchTags(tagIds: [$id], includeInactiveTags: true) {
    displayValue
    type
  }
}
